import*as React from"react";import{breakpoints,FlexLayout,mediaQuery}from"@wp/src/components/common/grid";import styled from"@emotion/styled";import{useResponsiveScreenWidth}from"@wp/src/components/common/responsive/useResponsive";import{css}from"@emotion/react";import{useOnboardingNavBarObserver}from"@wp/src/components/screenComponents/onboarding/NavigationGuide/useOnboardingNavigationState";const NavigationContainer=styled(FlexLayout)`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  ${mediaQuery({padding:["16px 16px","16px 32px"]})}

  background-color: ${props=>props.theme.colors.white};
  box-shadow: 0px 1px 0px 0px ${props=>props.theme.colors.neutral300} inset;

  ${props=>props.emphasizeLastAction?css`
          & > *:last-child {
            // The box-sizing ensures the padding and border of the element do not increase its width.
            // This helps in making the layout more predictable and aligns it within its container.
            box-sizing: border-box;

            // The padding is adjusted to give the last child more spacing on the right side in larger views.
            // This visually separates it from other elements, emphasizing it as the primary action.
            ${mediaQuery({padding:["0","0 64px","0 64px","0 96px"]})}
          }
        `:""};

  @media (max-width: ${breakpoints.sm}px) {
    & > *:only-child {
      // When there's only one child in mobile views, it takes up the full width for better touch accessibility.
      width: 100%;
    }

    ${props=>props.emphasizeLastAction?css`
            & > *:last-child {
              // In mobile views, if the last child is emphasized, it's allowed to grow and take up more space.
              // This makes it more noticeable and easier to interact with on touch devices.
              flex-grow: 1;
            }
          `:""};
  }
`;export const OnboardingNavigationWrapper=props=>{const navBarRef=React.useRef(null);const emphasizeLastAction=props.emphasizeLastAction??true;useOnboardingNavBarObserver(navBarRef);const{isBelow768}=useResponsiveScreenWidth();return React.createElement(NavigationContainer,{ref:navBarRef,flexDirection:"row",itemsSpacingHorizontal:16,itemsSpacingVertical:16,justifyContent:isBelow768?"space-between":"flex-end",alignItems:"center",emphasizeLastAction:emphasizeLastAction,className:props.className},props.children)};